import React from 'react';
import styled from 'styled-components';
import { useLocation, ScrollRestoration } from "react-router";
import Header from '../combinations/Header';
import Footer from '../combinations/Footer';
import Flash from '../parts/Flash';

type VisitorComponentProps = {
  children: React.ReactNode
}

const VisitorStyle = styled.div`
  background: #f2f0e9;
  font-family: 'Noto Sana JP', sans-serif;
  min-height: 100vh;
`;

const Visitor: React.FC<VisitorComponentProps> = (({ children }) => {
  const location = useLocation();
  const message = location.state?.message;
  const level = location.state?.level;

  return (
    <VisitorStyle>
      <Header />
        {level && <Flash level={level} message={message}/>}
        { children }
      <Footer backgroundColor='#f2f0e9' />
      <ScrollRestoration />
    </VisitorStyle>
  );
});
export default Visitor;
